import { useEffect, useId, useMemo } from 'react'

import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'

import { useDraggableModalStoreApi } from '../hooks'
import { DraggableModalState } from '../store/interface'

const useStoreUpdater = <
  K extends keyof DraggableModalState,
  T extends DraggableModalState[K]
>(
  key: K,
  value: T
) => {
  const { setState } = useDraggableModalStoreApi()

  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

export const DraggableModalStoreUpdater = () => {
  const id = useId()

  const { attributes, listeners, transform, setNodeRef } = useDraggable({
    id
  })

  const cssTransform = useMemo(
    () => CSS.Transform.toString(transform),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [transform?.x, transform?.y, transform?.scaleX, transform?.scaleY]
  )

  useStoreUpdater('id', id)
  useStoreUpdater('setNodeRef', setNodeRef)
  useStoreUpdater('attributes', attributes)
  useStoreUpdater('listeners', listeners)
  useStoreUpdater('transform', cssTransform)

  return null
}
